var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3065_4132",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0L0 7L7 14"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7L-1.06066 5.93934L-2.12132 7L-1.06066 8.06066L0 7ZM5.93934 -1.06066L-1.06066 5.93934L1.06066 8.06066L8.06066 1.06066L5.93934 -1.06066ZM-1.06066 8.06066L5.93934 15.0607L8.06066 12.9393L1.06066 5.93934L-1.06066 8.06066Z",
    fill: "white",
    mask: "url(#path-1-inside-1_3065_4132)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeft);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDcgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxtYXNrIGlkPSJwYXRoLTEtaW5zaWRlLTFfMzA2NV80MTMyIiBmaWxsPSJ3aGl0ZSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAwTDAgN0w3IDE0Ii8+CjwvbWFzaz4KPHBhdGggZD0iTTAgN0wtMS4wNjA2NiA1LjkzOTM0TC0yLjEyMTMyIDdMLTEuMDYwNjYgOC4wNjA2NkwwIDdaTTUuOTM5MzQgLTEuMDYwNjZMLTEuMDYwNjYgNS45MzkzNEwxLjA2MDY2IDguMDYwNjZMOC4wNjA2NiAxLjA2MDY2TDUuOTM5MzQgLTEuMDYwNjZaTS0xLjA2MDY2IDguMDYwNjZMNS45MzkzNCAxNS4wNjA3TDguMDYwNjYgMTIuOTM5M0wxLjA2MDY2IDUuOTM5MzRMLTEuMDYwNjYgOC4wNjA2NloiIGZpbGw9IndoaXRlIiBtYXNrPSJ1cmwoI3BhdGgtMS1pbnNpZGUtMV8zMDY1XzQxMzIpIi8+Cjwvc3ZnPgo=";